<template>
  <div
    class="h-divider"
    :style="{
      '--height': computedHeight,
      '--bg-color': color,
    }"
  ></div>
</template>

<script>
export default {
  props: {
    height: {
      type: [Number, String],
      default: "1px",
    },
    color: {
      type: String,
      default: "transparent",
    },
  },
  computed: {
    computedHeight() {
      switch (typeof this.height) {
        case "string":
          if (+this.height == this.height) return `${this.height / 20}rem`;
          return this.height;

        case "number":
          return `${this.height / 20}rem`;

        default:
          return `${1 / 20}rem`;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.h-divider {
  width: 100%;
  height: var(--height, 1px);
  background-color: var(--bg-color, transparent);
}
</style>
